export default __webpack_public_path__ + "static/media/starter_bundle.e45666df.webp";